/* eslint-disable jsx-a11y/no-onchange */
import React, { Fragment, useEffect, useState } from "react"
import {
  CloseButton,
  Modal,
  ModalBackdrop,
  ModalBody,
  ModalContent,
  ModalDialog,
} from "../Modal"
import CloseIcon from "../Icons/CloseIcon"
import {
  Form,
  FormAction,
  FormCol,
  FormRow,
  FormTitle,
  FormTwoCol,
} from "../Form"
import FormButton from "../button/FormButton"
import { navigate } from "gatsby"
import { FormWrap } from "./styles"
import HoneypotField from "../HoneypotField"
import {
  HONEYPOT_FIELD,
  validateLead,
  hasErrors,
} from "../../utils/leadValidation"
import {
  submitLead,
  captureAttribution,
  getAttributionPayload,
  pushLeadConversion,
  GENERIC_ERROR,
} from "../../utils/submitLead"

const QuotePopupModal = ({ isVisible, onClose, location }) => {
  const [firstname, setFirstName] = useState("")
  const [lastname, setLastName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [zipcode, setZipcode] = useState("")
  const [state, setState] = useState("")
  const [message, setMessage] = useState("")
  const [trap, setTrap] = useState("")
  const [errors, setErrors] = useState({})
  const [formError, setFormError] = useState("")
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    captureAttribution()
  }, [])

  const handleSubmit = async e => {
    e.preventDefault()
    if (submitting) return

    const fields = {
      first_name: firstname,
      last_name: lastname,
      email: email,
      phone_no: phone,
      state: state,
      zipcode: zipcode,
      comment: message,
    }

    const validationErrors = validateLead(fields)
    if (hasErrors(validationErrors)) {
      setErrors(validationErrors)
      setFormError("")
      return
    }

    const data = {
      source: location.origin,
      form: "Quote Form",
      page: window.location.href,
      first_name: firstname,
      last_name: lastname,
      email: email,
      phone_no: phone,
      state: state,
      zipcode: zipcode,
      comment: message,
      ...getAttributionPayload(),
      [HONEYPOT_FIELD]: trap,
    }

    setSubmitting(true)
    setFormError("")
    setErrors({})

    try {
      await submitLead(data)

      document.body.classList.remove("popup-open")
      pushLeadConversion({ email: email, phone: phone })

      setSubmitting(false)
      navigate("/thanks")
      if (typeof window !== `undefined`) {
        document.body.classList.remove("modal-open")
      }
    } catch (error) {
      setSubmitting(false)
      setErrors(error.fieldErrors || {})
      setFormError(error.message || GENERIC_ERROR)
    }
  }

  return (
    <Fragment>
      <Modal className="modal" hidden={!isVisible}>
        <ModalDialog className="modal-dialog modal-dialog-centered">
          <ModalContent className="modal-content">
            <ModalBody className="modal-body">
              <CloseButton className="close" onClick={() => onClose()}>
                <CloseIcon />
              </CloseButton>
              <FormTitle className="form-title">
                Get in touch with our building experts
              </FormTitle>
              <FormWrap onSubmit={handleSubmit} noValidate>
                <Form className="form">
                  <FormRow className="form-row">
                    <FormTwoCol className="form-coltwo">
                      <div className="form-group">
                        <input
                          type="text"
                          id="firstname"
                          className="form-control"
                          placeholder="First Name"
                          required
                          value={firstname}
                          onChange={e => setFirstName(e.target.value)}
                        />
                        {errors.first_name && (
                          <span className="form-error">{errors.first_name}</span>
                        )}
                      </div>
                    </FormTwoCol>
                    <FormTwoCol className="form-coltwo">
                      <div className="form-group">
                        <input
                          type="text"
                          id="lastname"
                          className="form-control"
                          placeholder="Last Name"
                          required
                          value={lastname}
                          onChange={e => setLastName(e.target.value)}
                        />
                        {errors.last_name && (
                          <span className="form-error">{errors.last_name}</span>
                        )}
                      </div>
                    </FormTwoCol>

                    <FormTwoCol className="form-coltwo">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Email ID"
                          required
                          value={email}
                          onChange={e => setEmail(e.target.value)}
                        />
                        {errors.email && (
                          <span className="form-error">{errors.email}</span>
                        )}
                      </div>
                    </FormTwoCol>
                    <FormTwoCol className="form-coltwo">
                      <div className="form-group">
                        <input
                          type="tel"
                          id="phone_no"
                          className="form-control"
                          placeholder="Phone Number"
                          required
                          value={phone}
                          onChange={e => setPhone(e.target.value)}
                        />
                        {errors.phone_no && (
                          <span className="form-error">{errors.phone_no}</span>
                        )}
                      </div>
                    </FormTwoCol>
                    <FormTwoCol className="form-coltwo">
                      <div className="form-group">
                        <input
                          type="text"
                          id="zip_code"
                          className="form-control"
                          placeholder="Zip Code"
                          required
                          value={zipcode}
                          onChange={e => setZipcode(e.target.value)}
                        />
                        {errors.zipcode && (
                          <span className="form-error">{errors.zipcode}</span>
                        )}
                      </div>
                    </FormTwoCol>
                    <FormTwoCol className="form-coltwo">
                      <div className="form-group form-group-select">
                        <select
                          id="state"
                          className="form-control"
                          value={state}
                          onChange={e => setState(e.target.value)}
                          required
                        >
                          <option value="">State</option>
                          <option value="AL">Alabama</option>
                          <option value="AK">Alaska</option>
                          <option value="AZ">Arizona</option>
                          <option value="AR">Arkansas</option>
                          <option value="CA">California</option>
                          <option value="CO">Colorado</option>
                          <option value="CT">Connecticut</option>
                          <option value="DE">Delaware</option>
                          <option value="DC">District Of Columbia</option>
                          <option value="FL">Florida</option>
                          <option value="GA">Georgia</option>
                          <option value="HI">Hawaii</option>
                          <option value="ID">Idaho</option>
                          <option value="IL">Illinois</option>
                          <option value="IN">Indiana</option>
                          <option value="IA">Iowa</option>
                          <option value="KS">Kansas</option>
                          <option value="KY">Kentucky</option>
                          <option value="LA">Louisiana</option>
                          <option value="ME">Maine</option>
                          <option value="MD">Maryland</option>
                          <option value="MA">Massachusetts</option>
                          <option value="MI">Michigan</option>
                          <option value="MN">Minnesota</option>
                          <option value="MS">Mississippi</option>
                          <option value="MO">Missouri</option>
                          <option value="MT">Montana</option>
                          <option value="NE">Nebraska</option>
                          <option value="NV">Nevada</option>
                          <option value="NH">New Hampshire</option>
                          <option value="NJ">New Jersey</option>
                          <option value="NM">New Mexico</option>
                          <option value="NY">New York</option>
                          <option value="NC">North Carolina</option>
                          <option value="ND">North Dakota</option>
                          <option value="OH">Ohio</option>
                          <option value="OK">Oklahoma</option>
                          <option value="OR">Oregon</option>
                          <option value="PA">Pennsylvania</option>
                          <option value="RI">Rhode Island</option>
                          <option value="SC">South Carolina</option>
                          <option value="SD">South Dakota</option>
                          <option value="TN">Tennessee</option>
                          <option value="TX">Texas</option>
                          <option value="UT">Utah</option>
                          <option value="VT">Vermont</option>
                          <option value="VA">Virginia</option>
                          <option value="WA">Washington</option>
                          <option value="WV">West Virginia</option>
                          <option value="WI">Wisconsin</option>
                          <option value="WY">Wyoming</option>
                        </select>
                        {errors.state && (
                          <span className="form-error">{errors.state}</span>
                        )}
                      </div>
                    </FormTwoCol>
                    <FormCol>
                      <div className="form-group">
                        <textarea
                          name="review"
                          rows="3"
                          type="text"
                          id="message"
                          className="form-control"
                          placeholder="Enter Your Message"
                          required
                          value={message}
                          onChange={e => setMessage(e.target.value)}
                        ></textarea>
                        {errors.comment && (
                          <span className="form-error">{errors.comment}</span>
                        )}
                      </div>
                    </FormCol>
                  </FormRow>
                  <HoneypotField
                    value={trap}
                    onChange={e => setTrap(e.target.value)}
                  />
                  {formError && (
                    <div className="form-error form-error-summary">
                      {formError}
                    </div>
                  )}
                  <FormAction className="form-action">
                    <FormButton text={submitting ? "Submitting..." : "Submit"} />
                  </FormAction>
                </Form>
              </FormWrap>
            </ModalBody>
          </ModalContent>
        </ModalDialog>
      </Modal>
      <ModalBackdrop hidden={!isVisible} />
    </Fragment>
  )
}

export default QuotePopupModal
